import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import { cmsRMNBannerSelector } from 'selectors/rmnBanners';
import RMN_BANNER_TYPES_CONSTANTS from 'components/Rmn/constants';
const { POSITIONS } = RMN_BANNER_TYPES_CONSTANTS;

import rmnAndPlaUtils from 'utils/rmnAndPla';
const { bannerCommonProps } = rmnAndPlaUtils;

const { wrapHOC } = FrameworkUtils;

const functions = {};

const withRmnBottomBannerProps = Component => {
    const fields = createSelector(
        cmsRMNBannerSelector,
        (_state, ownProps) => ownProps,
        (rmnBannersState, ownProps) => {
            const bannerProps = bannerCommonProps[ownProps.pageType]?.mainBannerProps;

            return {
                ...ownProps,
                contextId: rmnBannersState?.contextId,
                bannerProps: {
                    ...bannerProps,
                    position: ownProps?.position || POSITIONS.BOTTOM
                }
            };
        }
    );

    return wrapHOC(connect(fields, functions))(Component);
};

export { withRmnBottomBannerProps };
